<template>
  <Transition name="fade-page">
    <div v-if="isLobbyPage" id="nav-sections" class="nav-sections-wrap container">
      <NavSectionsInner />
    </div>
  </Transition>
</template>

<script>
import { PARAM_PAGE } from '@/components/Lobby/enum.js'
import NavSectionsInner from '~/components/Lobby/NavSections/NavSectionsInner'

export default {
  name: 'NavSections',
  components: {
    NavSectionsInner,
  },
  computed: {
    isLobbyPage() {
      return this.$route.params[PARAM_PAGE]
    },
  },
}
</script>

<style lang="scss" scoped>
.nav-sections-wrap {
  overflow: hidden;
}
</style>
